import React, { useEffect, useState } from "react";
import api from "../../services/api";
import StatCard from "../components/StatCard";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";


const Dashboard = () => {

    const [loading, setLoading] = useState(true);

    const [stats, setStats] = useState({
        totalCandidates: 0,
        totalRecruiters: 0,
        totalJobs: 0,
        totalApplications: 0,
        totalPayments: 0,
        totalRevenue: 0
    });

    useEffect(() => {
        fetchDashboard();
    }, []);

    const fetchDashboard = async () => {

    try {

        const token = localStorage.getItem("adminToken");

        const response = await api.get("/admin/dashboard");

        setStats({
            ...response.data.data,
            totalPayments: 0,
            totalRevenue: 0
        });

    } catch (error) {

        console.error("Dashboard Error:", error);

    } finally {

        setLoading(false);

    }

};

    if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Dashboard..."
            />

        );

    }

    return (
  <div>

    <PageHeader
      title="Dashboard"
      subtitle="Welcome to the HIRECURA Admin Panel"
      breadcrumb={[
        {
          label: "Dashboard",
        },
      ]}
    />

    {/* Statistics */}
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

      <StatCard
        title="Candidates"
        value={stats.totalCandidates}
        color="primary"
        change="+12%"
        changeType="increase"
      />

      <StatCard
        title="Recruiters"
        value={stats.totalRecruiters}
        color="success"
        change="+5%"
        changeType="increase"
      />

      <StatCard
        title="Jobs"
        value={stats.totalJobs}
        color="warning"
        change="+18%"
        changeType="increase"
      />

      <StatCard
        title="Applications"
        value={stats.totalApplications}
        color="info"
        change="+24%"
        changeType="increase"
      />

      <StatCard
        title="Payments"
        value={stats.totalPayments}
        color="secondary"
        change="+8%"
        changeType="increase"
      />

      <StatCard
        title="Revenue"
        value={`₹ ${Number(stats.totalRevenue).toLocaleString()}`}
        color="danger"
        change="+16%"
        changeType="increase"
      />

    </div>

    {/* Bottom Section */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">

      {/* Recent Activity */}
      <div className="bg-white rounded-3xl shadow-lg p-6">

        <h2 className="text-2xl font-bold text-gray-800 mb-5">
          Recent Activity
        </h2>

        <div className="space-y-4">

          <div className="border rounded-2xl p-4">
            <p className="font-semibold">
              New Candidate Registered
            </p>
            <p className="text-gray-500 text-sm">
              Activity data will be displayed here.
            </p>
          </div>

          <div className="border rounded-2xl p-4">
            <p className="font-semibold">
              New Recruiter Joined
            </p>
            <p className="text-gray-500 text-sm">
              Activity data will be displayed here.
            </p>
          </div>

          <div className="border rounded-2xl p-4">
            <p className="font-semibold">
              New Job Posted
            </p>
            <p className="text-gray-500 text-sm">
              Activity data will be displayed here.
            </p>
          </div>

        </div>

      </div>

      {/* Platform Overview */}
      <div className="bg-white rounded-3xl shadow-lg p-6">

        <h2 className="text-2xl font-bold text-gray-800 mb-5">
          Platform Overview
        </h2>

        <div className="space-y-5">

          <div className="flex justify-between">
            <span>Total Candidates</span>
            <strong>{stats.totalCandidates}</strong>
          </div>

          <div className="flex justify-between">
            <span>Total Recruiters</span>
            <strong>{stats.totalRecruiters}</strong>
          </div>

          <div className="flex justify-between">
            <span>Total Jobs</span>
            <strong>{stats.totalJobs}</strong>
          </div>

          <div className="flex justify-between">
            <span>Total Applications</span>
            <strong>{stats.totalApplications}</strong>
          </div>

          <div className="flex justify-between">
            <span>Total Payments</span>
            <strong>{stats.totalPayments}</strong>
          </div>

          <div className="flex justify-between text-lg font-bold text-teal-700 border-t pt-4">
            <span>Total Revenue</span>
            <span>
              ₹ {Number(stats.totalRevenue).toLocaleString()}
            </span>
          </div>

        </div>

      </div>

    </div>

  </div>
);

};

export default Dashboard;